'use client';

import { useEffect, useState } from 'react';
import { getEnvironment } from '@/lib/env';

export default function EnvironmentIndicator() {
  const [environment, setEnvironment] = useState<string>('');
  const [apiUrl, setApiUrl] = useState<string>('');
  
  useEffect(() => {
    // Only run on client side
    const env = process.env.NEXT_PUBLIC_APP_ENV || getEnvironment();
    setEnvironment(env);
    setApiUrl(process.env.NEXT_PUBLIC_API_URL || '');
  }, []);
  
  // Don't show in production - strict check to ensure it never appears in production
  if (environment === 'production' || process.env.NODE_ENV === 'production' || process.env.NEXT_PUBLIC_APP_ENV === 'production') {
    return null;
  }
  
  const bgColor = environment === 'development' 
    ? 'bg-blue-500' 
    : environment === 'staging' 
      ? 'bg-amber-500' 
      : 'bg-zinc-500';
  
  return (
    <div className={`fixed bottom-0 right-0 z-50 ${bgColor} text-white px-3 py-1 text-xs font-mono rounded-tl-md`}>
      {environment} | {apiUrl.split('/').slice(-3, -1).join('/')}
    </div>
  );
} 